
export function setIsWrapped(isWrapped) {
  return dispatch =>
    dispatch({
      type: "SET_ISWRAPPED",
      payload: isWrapped
    });
}
